<template>
<div id="app">
  <router-view></router-view>
</div>
</template>

<script>
import LoginPage from './components/login_components/Loginpage';
export default {
  name: "app",
  components:{
    "login-page": LoginPage,
  },
  data() {
    return {
      'auth': true,
    }
  },
  mounted: function() {
    console.log("MToken ", this.$store.state.token);
    return;
    if (this.$store.state.token == "") {
      this.auth;
    }
    else{
      this.auth = !this.auth;
    }

    console.log("APP", process.env.VUE_APP_BASE_URL);
    console.log("Two", process.env.VUE_APP_SERVICE_URL);
    // console.log("Three", process.env.VUE_APP_2C2P_SCRIPT_URL);
    // console.log("Four", process.env.VUE_APP_2C2P_ENDPOINT_URL);
  }
};
</script>
